export const API_PREFIX = "api"
